import {
  ExternalBankAccount,
  ExternalBankAccountStatus,
  PaymentMethodCapability
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountWithdrawalReady = (
  externalBankAccount: ExternalBankAccount
) =>
  (externalBankAccount.status === ExternalBankAccountStatus.VERIFIED ||
    externalBankAccount.status === ExternalBankAccountStatus.PENDING) &&
  !!externalBankAccount.capabilities?.includes(PaymentMethodCapability.PAYOUT);
